import { useNavigate  } from "react-router-dom";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { fetchWorklistRecords } from "../../../services/managerWorkListService";
import CustomPagination from "./CustomPagination";
import { imageIdGenerate } from "../../../utils/custom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import localStorageStore from "../../../utils/localStorageStore";
import role from "../../../utils/role";

const WorkListTable = ({ parentWorkList, changeParentList, filterList, setWorklistCount, filterPagination, setFilterPagination }) => {
  
  const [postData, setPostData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10);
  const navigate = useNavigate();
  const decryptRole = localStorageStore.getRole();
  const handleRedirect = (worklist_no) => {
    navigate(decryptRole === role.Manager || decryptRole === role.TeamLead || decryptRole === role.Admin ? "/manager-worklist-details" : decryptRole === role.Member ? "/member-worklist-details" : "", { state: { worklist_id: worklist_no } });
  };
 
  useEffect(() => {
    fetchWorklistData(filterList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentWorkList, currentPage, dataPerPage, filterList]);
 
  const fetchWorklistData = async () => {
    let response = {};
    if (filterPagination === true) {
      setCurrentPage(1);
      setFilterPagination(false);
    }
    const role = decryptRole
    response = await fetchWorklistRecords(filterList, currentPage, dataPerPage, role);
    setPostData(response?.data);
    changeParentList(false);
    setWorklistCount(response?.data?.totalRecords);
  };
  
  const currentData = postData?.worklistItem?.slice(0, 10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  return (
    <>
      <div className="card-body py-4">
        <div className="table-responsive">
          <table className="table to-do-table align-middle table-row-dashed fs-6 gy-5 gs-7" id="kt_table_users">
            <thead>
              <tr className="text-start fw-bold fs-7 text-uppercase gs-0">
                <th className="min-w-40px">Project ID</th>
                <th className="min-w-40px">Name</th>
                <th className="min-w-40px">Type</th>
                <th className="min-w-70px">Owner</th>
                <th className="min-w-200px">Progress</th>
                <th className="min-w-40px">Start </th>
                <th className="min-w-40px">End </th>
                <th className="min-w-40px">Status</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold">
              {currentData?.map((item, index) => (
                <tr
                  key={item?.id}
                  onClick={(e) => {
                    handleRedirect(item?.id);
                  }}
                >
                  <td>
                    <strong className="text-gray-900">{item?.worklist_no}</strong>
                  </td>
                  <td>{item?.name}</td>
                  <td>{item?.ProcessName}</td>
                  <td>
                    <div className="symbol-group symbol-hover flex-nowrap">
                        <OverlayTrigger overlay={<Tooltip>{item?.owner?.full_name}</Tooltip>} key={item?.owner?.id} placement={"right"} >
                          <div className="symbol symbol-35px symbol-circle user-image" data-kt-initialized="1">
                            <img alt="name" src={item?.owner?.image_url ?? `${process.env.PUBLIC_URL}/assets/media/avatars/300-${imageIdGenerate(item?.owner?.id)}.jpg`} />
                          </div>
                        </OverlayTrigger>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center flex-column mt-3 w-100">
                      <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                        {item?.total_tasks_count !== null && (
                          <>
                            <span className="fw-bold fs-6 text-gray-400">{(parseInt(item?.total_tasks_count) !==0 ? (100 - (parseInt(item?.unapproved_tasks_count) / parseInt(item?.total_tasks_count)) * 100).toFixed(2) + "%" : "No task assigned")}</span>
                            {parseInt(item?.total_tasks_count) !==0 && <span className="fw-semibold fs-6 text-dark">{(((parseInt(item?.unapproved_tasks_count)) / parseInt(item?.total_tasks_count) * 100).toFixed(2))}%</span>}
                          </>
                        )}
                      </div>
                      {(item?.total_tasks_count !== null && parseInt(item?.total_tasks_count) !== 0) ? (
                        <div className={(parseInt(item?.total_tasks_count) !== 0 ? (parseInt(item?.unapproved_tasks_count) / parseInt(item?.total_tasks_count)) * 100 : "No Tasks") === 0 ? "h-8px mx-3 w-100 bg-success rounded" : "h-8px mx-3 w-100 bg-light-warning rounded"}>
                          <div className={(parseInt(item?.total_tasks_count) !== 0 ? (parseInt(item?.unapproved_tasks_count) / parseInt(item?.total_tasks_count)) * 100 : "No Tasks") === 0 ? "bg-success rounded h-8px" : "bg-warning rounded h-8px"} role="progressbar" style={(parseInt(item?.total_tasks_count) !== 0 ? (parseInt(item?.unapproved_tasks_count) / parseInt(item?.total_tasks_count)) * 100 : 0) === 0 ? { width: "100%", ariaValuenow: "50", ariaValuemin: "0", ariaValuemax: "100" } : { width: `${parseInt(item?.total_tasks_count) !== 0 ? (100 - (parseInt(item?.unapproved_tasks_count) / parseInt(item?.total_tasks_count)) * 100): 0}%`, ariaValuenow: "50", ariaValuemin: "0", ariaValuemax: "100" }}></div>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </td>
                  <td>{moment(item?.start_date).format("DD-MMM-YY")}</td>
                  <td>{moment(item?.end_date).format("DD-MMM-YY")}</td>
                  <td>{item?.WorklistStatusName != null ? <div className={item?.WorklistStatusName?.toLowerCase() === "not started" ? "badge badge-light-info fw-bold" : item?.WorklistStatusName?.toLowerCase() === "closed" ? "badge badge-light-danger fw-bold" : item?.WorklistStatusName?.toLowerCase() === "in progress" ? "badge badge-light-primary fw-bold" : "badge badge-secondary fw-bold"}>{item?.WorklistStatusName}</div> : <div>---</div>}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {currentData?.length === 0 && <div>No Records Found ...</div>}
          {currentData?.length !== 0 && <CustomPagination dataPerPage={dataPerPage} totalData={postData?.totalRecords} paginate={paginate} currentPage={currentPage} />}
        </div>
      </div>
    </>
  );
};
export default WorkListTable;
